import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import DeviceTypeFilter from "./DeviceTypeFilter";
import AdvancedFilters from "./AdvancedFilters";
import { ROLES, useAuth } from "../../../auth";
import I18nText from "../../../elements/I18nText";

const FilterDialog = ({
  open,
  onClose,
  filters,
  onFilterChange,
  onTypeFilterChange,
  onClearAllFilters,
  hasActiveFilters,
  TYPE_BUTTONS,
  filterOptions,
  contentTypes,
  deviceStatuses
}) => {
  const { user, hasRole } = useAuth();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <I18nText>topbar.filter.filters</I18nText>
          {hasActiveFilters && (
            <Button
              size="small"
              onClick={onClearAllFilters}
              startIcon={<ClearIcon />}
            >
              <I18nText>topbar.filter.clearAll</I18nText>
            </Button>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {hasRole(user, ROLES.MASTER) && (
          <DeviceTypeFilter
            typeFilter={filters.typeFilter}
            onTypeFilterChange={onTypeFilterChange}
            TYPE_BUTTONS={TYPE_BUTTONS}
            showLabel={true}
          />
        )}

        <AdvancedFilters
          filters={filters}
          onFilterChange={onFilterChange}
          options={filterOptions}
          contentTypes={contentTypes}
          deviceStatuses={deviceStatuses}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <I18nText>topbar.filter.cancel</I18nText>
        </Button>
        <Button color="primary" variant="contained" onClick={onClose}>
          <I18nText>topbar.filter.apply</I18nText>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
